import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { getEmptyManifestContext } from './ManifestRuntimeContext';
import { ManifestResolver } from './ManifestResolver';
import { ManifestQuery } from './ManifestQuery';
var _resolvedRuntimeManifestContext = /*#__PURE__*/new WeakMap();
export class ManifestContextAPI {
  static resolveRuntimeManifest(runtimeManifestContext, childPath) {
    if (!(childPath != null && childPath.length)) {
      return runtimeManifestContext;
    }
    const tree = childPath.reduce((acc, index) => acc == null ? void 0 : acc.children[index], runtimeManifestContext.tree);
    return {
      ...runtimeManifestContext,
      tree: tree ?? getEmptyManifestContext('#').tree
    };
  }
  constructor(manifestQueryAPI, manifestResolverAPI, runtimeManifestContext, childPath, isReadonly) {
    if (childPath === void 0) {
      childPath = [];
    }
    if (isReadonly === void 0) {
      isReadonly = false;
    }
    this.manifestQueryAPI = manifestQueryAPI;
    this.manifestResolverAPI = manifestResolverAPI;
    this.runtimeManifestContext = runtimeManifestContext;
    this.childPath = childPath;
    this.isReadonly = isReadonly;
    _defineProperty(this, "resolver", void 0);
    _defineProperty(this, "query", void 0);
    _classPrivateFieldInitSpec(this, _resolvedRuntimeManifestContext, void 0);
    _classPrivateFieldSet(_resolvedRuntimeManifestContext, this, ManifestContextAPI.resolveRuntimeManifest(this.runtimeManifestContext, this.childPath));
    this.resolver = new ManifestResolver(this.manifestResolverAPI, _classPrivateFieldGet(_resolvedRuntimeManifestContext, this));
    this.query = new ManifestQuery(this.manifestQueryAPI, _classPrivateFieldGet(_resolvedRuntimeManifestContext, this), this.isReadonly);
  }
  getOriginalManifests() {
    return this.resolver.getOriginalManifests();
  }

  /**
   * editorPointer is null for a root element,
   * since root context might be built from the multiple components
   */
  getEditorPointer() {
    return _classPrivateFieldGet(_resolvedRuntimeManifestContext, this).tree.editorPointer;
  }
  getDisplayName() {
    var _classPrivateFieldGet2;
    return (_classPrivateFieldGet2 = _classPrivateFieldGet(_resolvedRuntimeManifestContext, this).tree.manifest.editorElement) == null ? void 0 : _classPrivateFieldGet2.displayName;
  }
  getChildren() {
    return this.resolver.getChildren().map(child => {
      return new ManifestContextAPI(this.manifestQueryAPI, this.manifestResolverAPI, {
        ...this.runtimeManifestContext,
        tree: child
      }, this.childPath, this.isReadonly);
    });
  }
}
//# sourceMappingURL=ManifestContextAPI.js.map